import React, { useEffect, useState } from "react";
import { TextField, Button } from "@mui/material";
import { Add, Remove } from "@mui/icons-material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

const QtyInput = (props) => {
  const {
    value = 1,
    onChange,
    onChangeRemoveItem,
    buttonShow = true,
  } = props || {};

  const [qty, setQty] = useState(value);

  useEffect(() => {
    setQty(value);
  }, [value]);

  const handleIncrement = () => {
    setQty((prev) => prev + 1);
    if (buttonShow === false) {
      onChange(1, "add");
    }
  };

  const handleDecrement = () => {
    setQty((prev) => (prev > 1 ? prev - 1 : prev));
    if (buttonShow === false) {
      const newQty = qty - 1;
      if (newQty > 0) {
        onChange(1, "remove");
      }
    }
  };

  const handleConfirm = () => {
    onChange?.(qty);
  };

  const handleDeleteItem = () => {
    onChangeRemoveItem?.(qty);
  };

  return (
    <div className="qty-input-container">
      <Button
        onClick={handleDecrement}
        size="small"
        className="qty-button minus"
      >
        <Remove />
      </Button>
      <TextField
        value={qty}
        className="qty-input"
        variant="outlined"
        size="small"
        inputProps={{
          readOnly: true,
          style: { textAlign: "center", width: "50px", pointerEvents: "none" },
        }}
      />
      <Button
        onClick={handleIncrement}
        size="small"
        className="qty-button plus"
      >
        <Add />
      </Button>
      {buttonShow ? (
        <Button
          variant="contained"
          onClick={handleConfirm}
          className="add-button-cart"
        >
          <ShoppingCartIcon />
        </Button>
      ) : (
        <div className="delete-item-from-cart" onClick={handleDeleteItem}>
          <img src="/images/removeItem.png" className="img-fluid" alt="LG" />
        </div>
      )}
    </div>
  );
};

export default QtyInput;
